export default "<span>{{tier}}</span>\r\n<label>{{label}}</label>\r\n\r\n\r\n\r\n\r\n";